import { connect } from 'react-redux'

import AdministrationSidebarNavigationComponent from './component'

const AdministrationSidebarNavigationContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {}
)(AdministrationSidebarNavigationComponent)

export default AdministrationSidebarNavigationContainer
